/**
 * Filters regex characters from string
 * @param string {string}
 * @returns {string}
 */
export default function escapeRegexCharacters(string) {
    return string.replace(/[*+?^$%{}|[\]\\]/g, '');
}